<template>
  <v-combobox
    v-model="coupon"
    :items="couponOptions"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    auto-select-first
    item-text="CouponName"
    :label="label"
    :prepend-inner-icon="mdiMapMarker"
    return-object no-filter
    :error-messages="errorMessages"
    outlined
    hide-details
    clearable
    v-on:click:clear="clear"
    :inputmode="inputmode"
  ></v-combobox>
</template>

<script>
import {mdiMapMarker} from "@mdi/js";
import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import { SelectCoupon } from "@/api/publicServices";
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    cachedCoupons: {
      type: Array
    },
    errorMessages: {
      type:String
    },
    onChange: {
      type:Function
    }
  },
  data: () => ({
    couponOptions: [{
      CouponName: ''
    }],
    isLoading: false,
    search: null,
    coupon: {
      CouponName: ''
    },
    isClear: false,

    //svg icons
    mdiMapMarker,
  }),
  computed: {
    inputmode() {
      return  localStorage.getItem("flutter") == "true" || this.$isMobile()?"none":"text";
    },
  },
  created: function() {
    this.debouncedSearchCoupon = debounce(this.searchCoupon, 500);
    this.debouncedFilterCachedCoupon = debounce(this.filterCachedCoupons, 500);
  },
  methods: {
    async searchCoupon(searchVal) {
      if (this.isClear) {
        this.isClear = false;
        return;
      }
      if (this.isLoading) return;
      if (searchVal != '' && !isEmpty(this.coupon) && this.coupon.CouponName === searchVal) return;
      this.isLoading = true;
      try {
        const response = await SelectCoupon({ "searchVal": searchVal });
        console.log(`response:${response}`);
        this.isLoading = false;
        this.couponOptions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    filterCachedCoupons(searchVal) {
      if (this.isLoading) return;
      if (searchVal.length === 0) return;
      const searchText = searchVal.toLowerCase();
      this.couponOptions = this.cachedCoupons.filter(coupon => {
        return coupon.CouponName.toLowerCase().indexOf(searchText) > -1;
      });
      this.isLoading = false;
    },
    resetCoupon() {
      this.coupon = {};
      this.coupon.CouponName = '';
    },
    clear() {
      this.isClear = true;
      console.log("isClear");
    },
  },
  watch: {
    search(newVal) {
      if (this.cachedCoupons && this.cachedCoupons.length > 0) {
        this.debouncedFilterCachedCoupon(newVal);
      } else {
        this.debouncedSearchCoupon(newVal);
      }
    },
    coupon() {
      this.$emit("input", this.coupon);
    }
  }
};
</script>